import React from 'react';
import { Box } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import './ProgressBar.css';

const STATUS_CLASS = {
  FAILED: 'ProgressBar-fill--failed',
  COMPLETED: 'ProgressBar-fill--completed',
};

function ProgressBar({ pct, status, phaseLabel }) {
  const fillClass = `ProgressBar-fill ${
    STATUS_CLASS[status] || 'ProgressBar-fill--running'
  }`;

  return (
    <Box className='ProgressBar'>
      {phaseLabel && (
        <Box tag='span' className='ProgressBar-phase'>
          {phaseLabel}
        </Box>
      )}
      <Box className='ProgressBar-track'>
        <Box
          className={fillClass}
          style={{ width: `${pct}%`, transition: 'width 0.5s ease' }}
        />
      </Box>
      <Box tag='span' className='ProgressBar-label'>
        {pct}%
      </Box>
    </Box>
  );
}

ProgressBar.propTypes = {
  pct: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  phaseLabel: PropTypes.string,
};

ProgressBar.defaultProps = {
  phaseLabel: null,
};

export default ProgressBar;
